<template>
  <div>
    <PCMenu :memberSystem="company" />
    <div class="main m-t-20">
      <div class="max-w1200 m-auto flex">
        <div class="left" >

          <form class="layui-form" action="" lay-filter="selectform">
            <div style="background:#f6f6f6;" >
              <div class="layui-form-item">
                <label>选择车系</label>
                <div>
                  <select data-layer="0"  lay-filter="chexi" name="chexi" lay-verify="required">
                    <!-- <option value=""></option> -->
                    <option v-for="tab in tabs" :key="tab.id" :value="tab.id" :selected="tab.id==activeTab?true:false">{{tab.name}}</option>
                  </select>
                </div>
              </div>
              <div class="layui-form-item">
                <label>选择品牌</label>
                <div>
                  <select data-layer="1" name="brand" lay-verify="required">
                    <option value=""></option>
                    <option v-for="tab in selectData[0]" :key="tab.id" :value="tab.id" :selected="tab.id==activeBrandId?true:false">{{tab.name}}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="m-t-10">
              <div class="layui-form-item">
                <label>选择车型</label>
                <div>
                  <select data-layer="2" name="chexing" lay-verify="required">
                    <option value=""></option>
                    <template v-if="selectData.length>1 ">
                      <option v-for="tab in selectData[1].children" :key="tab.id" :value="tab.id">{{tab.name}}</option>
                    </template>
                  </select>
                </div>
              </div>
              <div class="layui-form-item">
                <label>选择年份</label>
                <div>
                  <select data-layer="3" name="year" lay-verify="required">
                    <option value=""></option>
                    <template v-if="selectData.length>2 ">
                      <option v-for="tab in selectData[2].children" :key="tab.id" :value="tab.id">{{tab.name}}</option>
                    </template>
                  </select>
                </div>
              </div>
              <div class="layui-form-item">
                <label>选择排气量或电动</label>
                <div>
                  <select data-layer="4" name="paiqiliang" lay-verify="required">
                    <option value=""></option>
                    <template v-if="selectData.length>3 ">
                    <option v-for="tab in selectData[3].children" :key="tab.id" :value="tab.id">{{tab.name}}</option>
                    </template>
                  </select>
                </div>
              </div>
              <div v-if="params.type==1" class="layui-form-item">
                <label>选择发动机</label>
                <div>
                  <select data-layer="5" name="fadongji" lay-verify="required">
                    <option value=""></option>
                    <template v-if="selectData.length>4 ">
                    <option v-for="tab in selectData[4].children" :key="tab.id" :value="tab.id">{{tab.name}}</option>
                    </template>
                  </select>
                </div>
              </div>
              <div class="layui-form-item">
                <button class="layui-btn layui-btn-fluid" lay-submit lay-filter="formDemo">资料查询</button>
              </div>
            </div>
          </form>
        </div>
        <div class="right m-l-20">
          <ul class="nav flex">
            <li @click="toggleTab(tab.id)" v-for="tab in tabs" :key="tab.id" :class="tab.id==activeTab?'active':''">{{tab.name}}</li>
          </ul>
          <div style="color:red;margin-top:5px;text-align: center;">点击图标选择车系品牌后，请继续在左侧选择具体车型查询！</div>
          <div class="content">
            <ul class="flex">
              <li class="cursor-point" v-for="brand in brands" :key="brand.id" @click="toggleBrand(brand.id)">
                <div class="brandpic"><img style="width:100%" :src="global.getStaticFilePath(brand.picUrl,'/wx')"></div>
                <div class="title">{{brand.name}}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
<!--    <PCCopyright />-->
  </div>
</template>

<script>
import PCMenu from "@/components/PCMenu.vue";
import PCCopyright from "@/components/PCCopyright.vue";
import { Get_Brand_Tree, Get_Brand_Node } from "@/api/index";

import {Icon, Popup} from "vant";

export default {
  name: "PcChoose",
  components: {
    PCMenu,
    PCCopyright,
    [Icon.name]: Icon,
  },
  data() {
    return {
      tabs: [],
      brands: [],
      activeTab: 0,
      activeBrandId: 0,
      selectData: [],
      company: {},
      hideLeft:false,
      params: {
        type: this.$route.params.type,
      },
    };
  },
  methods: {
    async getBrandTree() {
      this.params.regionType = this.company.type;
      this.tabs = await Get_Brand_Tree(this.params);
    },
    chexiChanged(){
      debugger
      console.log(arguments)
    },
    toggleTab: function (id) {
      this.activeTab = id;
      this.brands = this.tabs.find((m) => m.id == id).children;
      this.selectData.splice(0, 10, this.tabs.find((m) => m.id == id).children);
      // this.form.val("selectform", { "chexing": id});
    },
    toggleBrand: function (id) {
      this.activeBrandId = id;
      this.getBrandNode(id, 1);
    },
    async getBrandNode(id, layer) {
      if (id == "") {
        return;
      }
      var params = {
        id: id,
        depth: 2,
        regionType: this.company.type,
      };
      var node = await Get_Brand_Node(params);

      this.selectData.splice(layer, 10, node);
    },
  },
  mounted() {
    const _this = this;
    layui.use(["jquery", "layer", "form"], function () {
      var layer = layui.layer,
        $ = layui.jquery,
        form = layui.form;
      _this.form = layui.form;

      _this.global.getMemberSystem().then((memberSystem) => {
        if (!_this.global.isNull(memberSystem)) {
          _this.company = memberSystem;
          _this.getBrandTree();
        }
      });
      // _this.getBrandTree();

      form.on("select", function (data) {
        var layer = parseInt($(data.elem).data("layer"));

        if (data.value == "") {
          _this.selectData.splice(layer, 10);
          return;
        }
        if (layer == 0) {
          _this.toggleTab(data.value)
          // _this.selectData.splice(
          //   layer,
          //   10,
          //   _this.tabs.find((m) => m.id == data.value).subList
          // );
        } else {
          _this.getBrandNode(data.value, layer);
        }
      });

      form.on("submit(formDemo)", function (data) {
        let param = data.field.paiqiliang;
        if (_this.params.type == "1") {
          param = data.field.fadongji;
        }
        _this.$router.push({ path: "/pc/fileshow/" + param });
        return false;
      });
    });
  },
  watch: {
    tabs: function (val) {
      this.activeTab = this.tabs[0].id;
      this.toggleTab(this.activeTab);
      this.$nextTick(function () {
        this.form.render();
      });
    },
    selectData: function (val) {
      this.$nextTick(function () {
        this.form.render();
      });
    },
    // activeTab: function (val) {
    //   this.$nextTick(function () {
    //     this.selectData.splice(
    //       0,
    //       10,
    //       this.tabs.find((m) => m.id == val).subList
    //     );
    //     this.form.render();
    //   });
    // },
  },
};
</script>
